// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import cn from 'classnames';
import Icon_ddc from '../../img/icons/24/color/dedicated_dc.svg';
import Icon_shared_dc from '../../img/icons/24/color/shared_dc.svg';
import Icon_isp from '../../img/icons/24/color/isp.svg';
import Icon_isp_plus from '../../img/icons/24/color/isp_premium.svg';
import Icon_smart_resi from '../../img/icons/24/color/residential.svg';
import Icon_ecommerce from '../../img/icons/24/color/events_and_ecommerce.svg';
import Icon_sneakers from '../../img/icons/24/color/sneakers.svg';
import Icon_resi_tickets from '../../img/icons/24/color/events_resi.svg';
import {i_product, Product_card} from '../homepage/products';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import styles from './check_products.module.less';
import {Editor} from '../../../../shared/editor/editor';

const products=(show_promo: boolean):i_product[]=>[
    {
        id: 'shared_dc',
        icon: <Icon_shared_dc />,
        title: 'Shared Datacenter Proxies',
        description: 'Cost-efficient proxies offering reliable performance.',
        btn_caption: show_promo ? 'Free trial': 'Starts from $0.1/GB',
        btn_link: '/pricing/shared_dc',
        show_promo,
    },
    {
        id: 'dedicated_dc',
        icon: <Icon_ddc />,
        title: 'Dedicated Datacenter Proxies',
        description: 'Premium, exclusive proxies delivering top-tier speed '+
            'and privacy.',
        btn_caption: 'Starts from $0.50/IP',
        btn_link: '/pricing/dedicated_dc',
    },
    {
        id: 'shared_isp',
        icon: <Icon_isp />,
        title: 'ISP Proxies',
        description: 'Global IPs for access to any site, except social media '+
            '& search engines.',
        btn_caption: 'Starts from $0.50/GB',
        btn_link: '/pricing/shared_isp',
    },
    {
        id: 'isp_plus',
        icon: <Icon_isp_plus />,
        title: 'ISP Premium Proxies',
        description: 'US-based IPs for accessing search engines and social '+
            'media.',
        btn_caption: 'Starts from $0.75/IP',
        btn_link: '/pricing/isp_plus',
    },
    {
        id: 'smart_resi',
        icon: <Icon_smart_resi />,
        title: 'Rotating Residential Proxies',
        description: 'Read-only IPs for smooth and consistent data access.',
        btn_caption: 'Starts from $1/GB',
        btn_link: '/pricing/smart_resi',
    },
    {
        id: 'events_isp',
        icon: <Icon_ecommerce />,
        title: 'Events & E-commerce Proxies',
        description: `Ideal for top event spots and smooth
            e-commerce access.`,
        btn_caption: 'Starts from $0.57/IP',
        btn_link: '/pricing/events_isp',
    },
    {
        id: 'resi_sneakers',
        icon: <Icon_sneakers />,
        title: 'Sneakers Residential Proxies',
        description:
            `Full access to top sneaker sites with no KYC process required!`,
        btn_caption: 'Starts from $0.85/GB',
        btn_link: '/pricing/resi_sneakers',
    },
    {
        id: 'events_resi_tickets',
        icon: <Icon_resi_tickets />,
        title: 'Tickets Residential Proxies',
        description:
            `Full access to leading ticket sites, requiring a KYC process.`,
        btn_caption: 'Starts from $0.68/GB',
        btn_link: '/pricing/events_resi_tickets',
    },
];

const Welcome_card = ()=>{
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    const mobile = width > 768 ? false : true;
    return <div className={cn(styles.welcome, mobile && styles.mobile)}>
    <div className={styles.title}>
      {mobile ? <h2 className={theme.H2}>
        Check Other<br/>Products
      </h2> : <h3 className={theme.H3}>
        Check Other<br/>Products
      </h3>}
    </div>
    <div className={styles.subtitle}>
      <p className={cn(theme.p18, theme.med)}>
        Choose what best matches your<br/>needs, goals and budget
      </p>
    </div>
  </div>;
};

interface i_check_products_props {
    exclude_product: string;
    short_cards?: boolean;
}

interface i_check_products_props_ed {
    value: i_check_products_props;
    on_change: (v:i_check_products_props)=>void;
    on_cancel: ()=>void;
}
export const Check_products_editor = (props: i_check_products_props_ed)=>{
    const [state, set_state] = useState<i_check_products_props>(props.value);
    return <Editor
      value={state}
      editors={[
        {key: 'exclude_product', label: 'id_product', type: 'text'},
      ]}
      on_change={v=>set_state(v)}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}/>;
};

export const Check_products = (props: i_check_products_props)=>{
    const {theme} = useContext(Settings_context);
    const {show_free_zone_promo} = use_app_context();
    const {exclude_product, short_cards} = props;
    const filtered_products = products(show_free_zone_promo).filter(product=>
        product.id !== exclude_product
    );
    return <div className={cn(theme.container, styles.check_products)}>
        <div className={styles.main_box_grid}>
          <Welcome_card />
          {filtered_products.map((product, index)=>
            <Product_card
              key={index}
              product={product}
              with_bar={false}
              with_features={false}
              with_description={!short_cards}
              btn_color={product.show_promo ? undefined : 'secondary'}/>
          )}
        </div>
    </div>;
};
